export default {
  title: 'Celulares',
  pair_button: 'Parear celular',
  pair_title: 'Parear novo celular',
  pair_hint: 'No celular da pessoa: instale o {app}, abra e digite o código de 7 dígitos.',
  new_person: '— Nova pessoa —',
  person_name_placeholder: 'Nome da pessoa (ex.: Ana)',
  generate_code: 'Gerar código',
  code_failed: 'Não foi possível gerar o código.',
  approve_failed: 'Falha ao aprovar.',
  revoke_failed: 'Falha ao revogar.',
  load_failed: 'Não foi possível carregar os celulares.',
  retry_hint: 'Tente novamente em instantes.',
  pairing_with: 'Pareando {name}',
  enter_code: 'Digite este código no app do celular dela:',
  expires_in: 'expira em {time}',
  device_label: 'Aparelho: {label}',
  confirm_phrase_title: 'Confirme com a pessoa — a frase no celular dela deve ser idêntica:',
  confirm_phrase_hint: 'Se as frases divergirem, cancele: outro aparelho pode estar tentando parear.',
  phrases_match: 'Frases conferem — autorizar',
  cancel_pairing: 'Cancelar pareamento',
  paired_done: 'Pareamento concluído — o celular já aparece abaixo.',
  session_ended: 'Sessão {state}.',
  empty_title: 'Nenhum celular pareado.',
  empty_body: 'Pareie o aparelho da pessoa pelo app LOCZI Mobile para ver a localização dela aqui.',
  filter_aria: 'Filtrar aparelhos',
  section_devices: 'Aparelhos',
  filter_active: 'Ativos',
  filter_revoked: 'Revogados',
  filter_all: 'Todos',
  empty_active_title: 'Nenhum aparelho ativo.',
  empty_active_body: 'Todos os aparelhos pareados estão revogados — ou pareie um novo celular.',
  empty_revoked_title: 'Nenhum aparelho revogado.',
  empty_revoked_body: 'Aparelhos cujo acesso foi revogado aparecem aqui.',
  device_fallback: 'Celular',
  seen_at: 'visto {time}',
  position_at: 'posição {time}',
  emergency_active: 'Emergência ativa — localização sendo enviada continuamente',
  view_on_map: 'Ver no mapa',
  revoke: 'Revogar',
  revoked_badge: 'Revogado',
  revoke_confirm: 'Revogar o acesso de {name}? O app vai parar de enviar localização.',
  device_fallback_name: 'este celular',
  ago_now: 'agora mesmo',
  ago_min: 'há {count} min',
  ago_h: 'há {count} h',
  controls_unlink: 'Desvínculo pelo app',
  controls_unlink_hint_on: 'O usuário do celular pode encerrar o vínculo no app.',
  controls_unlink_hint_off: 'Bloqueado: o usuário do celular não pode cancelar o vínculo.',
  controls_stealth: 'Modo oculto',
  controls_stealth_hint_on: 'Ícone oculto no aparelho; a localização continua sendo enviada.',
  controls_stealth_hint_off: 'Ícone visível no aparelho.',
  controls_failed: 'Falha ao atualizar o controle.',
  controls_saved: 'Salvo',
  beep: 'Apitar',
  beep_hint: 'O aparelho toca um alarme no próximo contato (mesmo no silencioso).',
  beep_waiting: 'Aguardando aparelho…',
  beep_sent: 'Sinal enviado',
  beep_failed: 'Falha ao enviar o sinal.',
  schedule_title: 'Janela de rastreio',
  schedule_off: '24h',
  schedule_on: '{start}–{end}',
  schedule_enable: 'Restringir coleta a uma janela',
  schedule_days: 'Dias da semana',
  schedule_start: 'Início',
  schedule_end: 'Fim',
  schedule_hint: 'O aparelho só registra posições dentro dos dias e horários marcados. Fora da janela, nada é gravado — nem na fila local.',
  schedule_invalid: 'Marque ao menos um dia da semana.',
  day_0: 'Dom', day_1: 'Seg', day_2: 'Ter', day_3: 'Qua', day_4: 'Qui', day_5: 'Sex', day_6: 'Sáb',
  consent_until: 'Consentimento válido até {date}',
  consent_expired: 'Consentimento expirado — coleta pausada até renovação no aparelho',
  evidence: 'Evidência',
  evidence_hint: 'Exporta o histórico de posições com assinaturas e cadeia de hash (prova forense).',
  evidence_failed: 'Falha ao exportar a evidência.',
}
